export const LABELS = [
  'Anatomy',
  'LV Qi Stagnation',
  'Rebellious LV Qi',
  'LV Blood Stasis',
  'LV Blood Deficiency',
  'LV Yin Deficiency',
  'LV Yang Rising',
  'LV Fire Blazing',
  'Extreme Heat → Wind',
  'Yang Rising → Wind',
  'LV Blood Def → Wind',
  'Cold Stagnation in LV',
  'Damp Heat in LV',
  'LV Fire Insulting LU',
  'LV Invading the SP',
  'LV Invading the ST',
  'Rebellious ST Qi',
  'ST Qi Deficiency',
  'ST Deficient + Cold',
  'Cold Invasion in ST',
  'ST Yin Deficiency',
  'Damp Heat in ST',
  'ST Fire or Phlegm Fire in ST',
  'ST Food Retention',
  'ST Blood Stasis',
  'SP Qi Deficiency',
  'SP Qi Sinking',
  'SP Not Holding Blood',
  'SP Qi Def → Damp',
  'SP Yang Deficiency',
  'Damp Cold in SP',
  'Damp Heat invading the SP/ST',
  'HT Qi Def',
  'HT Yang Def',
  'HT Yang Collapse',
  'HT Blood Def',
  'HT Yin Deficiency',
  'HT Qi Stagnation',
  'HT Vessel Obstruction',
  'HT Blood Stasis',
  'HT Fire Blazing',
  'Phlegm Fire Harassing HT',
  'Phlegm Misting the Mind',
  'KD Qi Def',
  'KD Yang Def',
  'KD Yin Def',
  'KD Essence Def',
  'KD Yang Def → Water Overflowing',
  'KD Yin Def → Empty Fire Blazing',
  'KD not receiving Qi',
  'KD Qi not Firm',
  'KD/HT Disharmony',
  'LI Heat',
  'Heat Obstructing LI',
  'Dryness in LI',
  'LI Cold',
  'Cold invading LI',
  'LI Qi Stagnation',
  'LI Collapse',
  'Damp Heat in LI',
  'LU Qi Deficiency',
  'LU Dryness',
  'LU Yin Deficiency',
  'LU Heat',
  'Wind Cold Invasion',
];

export const labelToColor: Record<string, string> = {
  // Anatomy - Neutral blue
  'Anatomy': 'rgb(96, 125, 139)',
  
  // Liver (LV) patterns - Green tones
  'LV Qi Stagnation': 'rgb(76, 175, 80)',
  'Rebellious LV Qi': 'rgb(139, 195, 74)',
  'LV Blood Stasis': 'rgb(104, 159, 56)',
  'LV Blood Deficiency': 'rgb(165, 214, 167)',
  'LV Yin Deficiency': 'rgb(200, 230, 201)',
  'LV Yang Rising': 'rgb(129, 199, 132)',
  'LV Fire Blazing': 'rgb(67, 160, 71)',
  'Extreme Heat → Wind': 'rgb(46, 125, 50)',
  'Yang Rising → Wind': 'rgb(27, 94, 32)',
  'LV Blood Def → Wind': 'rgb(76, 175, 80)',
  'Cold Stagnation in LV': 'rgb(56, 142, 60)',
  'Damp Heat in LV': 'rgb(102, 187, 106)',
  'LV Fire Insulting LU': 'rgb(76, 175, 80)',
  'LV Invading the SP': 'rgb(76, 175, 80)',
  'LV Invading the ST': 'rgb(76, 175, 80)',
  
  // Stomach (ST) patterns - Orange/Yellow tones
  'Rebellious ST Qi': 'rgb(255, 152, 0)',
  'ST Qi Deficiency': 'rgb(255, 193, 7)',
  'ST Deficient + Cold': 'rgb(255, 183, 77)',
  'Cold Invasion in ST': 'rgb(255, 171, 0)',
  'ST Yin Deficiency': 'rgb(255, 213, 79)',
  'Damp Heat in ST': 'rgb(255, 167, 38)',
  'ST Fire or Phlegm Fire in ST': 'rgb(255, 143, 0)',
  'ST Food Retention': 'rgb(255, 197, 7)',
  'ST Blood Stasis': 'rgb(255, 160, 0)',
  
  // Spleen (SP) patterns - Yellow/Brown tones
  'SP Qi Deficiency': 'rgb(255, 193, 7)',
  'SP Qi Sinking': 'rgb(255, 183, 77)',
  'SP Not Holding Blood': 'rgb(255, 213, 79)',
  'SP Qi Def → Damp': 'rgb(255, 171, 0)',
  'SP Yang Deficiency': 'rgb(255, 167, 38)',
  'Damp Cold in SP': 'rgb(255, 143, 0)',
  'Damp Heat invading the SP/ST': 'rgb(255, 197, 7)',
  
  // Heart (HT) patterns - Red tones
  'HT Qi Def': 'rgb(244, 67, 54)',
  'HT Yang Def': 'rgb(229, 57, 53)',
  'HT Yang Collapse': 'rgb(211, 47, 47)',
  'HT Blood Def': 'rgb(198, 40, 40)',
  'HT Yin Deficiency': 'rgb(183, 28, 28)',
  'HT Qi Stagnation': 'rgb(255, 87, 34)',
  'HT Vessel Obstruction': 'rgb(255, 61, 0)',
  'HT Blood Stasis': 'rgb(255, 41, 0)',
  'HT Fire Blazing': 'rgb(255, 23, 68)',
  'Phlegm Fire Harassing HT': 'rgb(255, 0, 0)',
  'Phlegm Misting the Mind': 'rgb(220, 20, 60)',
  
  // Kidney (KD) patterns - Blue/Purple tones
  'KD Qi Def': 'rgb(63, 81, 181)',
  'KD Yang Def': 'rgb(48, 63, 159)',
  'KD Yin Def': 'rgb(33, 150, 243)',
  'KD Essence Def': 'rgb(30, 136, 229)',
  'KD Yang Def → Water Overflowing': 'rgb(25, 118, 210)',
  'KD Yin Def → Empty Fire Blazing': 'rgb(21, 101, 192)',
  'KD not receiving Qi': 'rgb(13, 71, 161)',
  'KD Qi not Firm': 'rgb(103, 58, 183)',
  'KD/HT Disharmony': 'rgb(156, 39, 176)',
  
  // Large Intestine (LI) patterns - Brown/Orange tones
  'LI Heat': 'rgb(139, 69, 19)',
  'Heat Obstructing LI': 'rgb(160, 82, 45)',
  'Dryness in LI': 'rgb(210, 180, 140)',
  'LI Cold': 'rgb(205, 133, 63)',
  'Cold invading LI': 'rgb(222, 184, 135)',
  'LI Qi Stagnation': 'rgb(188, 143, 143)',
  'LI Collapse': 'rgb(165, 42, 42)',
  'Damp Heat in LI': 'rgb(178, 34, 34)',
  
  // Lung (LU) patterns - Light Blue/Gray tones
  'LU Qi Deficiency': 'rgb(176, 196, 222)',
  'LU Dryness': 'rgb(135, 206, 235)',
  'LU Yin Deficiency': 'rgb(70, 130, 180)',
  'LU Heat': 'rgb(100, 149, 237)',
  'Wind Cold Invasion': 'rgb(72, 61, 139)',
};
